module.exports = __webpack_public_path__ + "static/media/CircularStd-BookItalic.cdf3e399.ttf";